<template>
    <div>
        <h4 class="text-xl text-center font-semibold mb-5">
            Newest Products
            <loader :loading="loading" class="ml-2" />
        </h4>

        <!-- <div v-for="index in 5" :key="index" class="my-3 h-12 placeholder-media w-full">
            <div class="line my-2"></div>
        </div> -->

        <div v-cloak v-show="!loading">
            <div class="px-5 lg:px-6">
                <div v-cloak v-if="!emptyProducts" class="mx-auto text-center">
                    <product-card v-for="product in products" :key="product.id" :product="product" :block="true" size="sm" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        limit: {
            type: [Number, String],
            default: 10
        }
    },

    data: () => ({
        products: [],
        loading: false
    }),

    created() {
        this.fetchProducts();
    },

    mounted() {},

    watch: {
        // products: {
        //     handler() {},
        //     deep: true
        // }
    },

    computed: {
        emptyProducts() {
            return this.products.length == 0;
        }
    },

    methods: {
        fetchProducts() {
            this.loading = true;

            axios.get("/api/products/newest", {
                    params: {
                        limit : this.limit
                    }
                })
                .then(response => {
                    this.products = response.data;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
